import { render, staticRenderFns } from "./MspAndatureDettaglio.vue?vue&type=template&id=cf6ba62a"
import script from "./MspAndatureDettaglio.vue?vue&type=script&lang=js"
export * from "./MspAndatureDettaglio.vue?vue&type=script&lang=js"
import style0 from "./MspAndatureDettaglio.vue?vue&type=style&index=0&id=cf6ba62a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports